import { NgModule, Sanitizer } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { TranslateService } from 'ng2-translate';
import { AlertService } from 'ng-jhipster';

import {
    DeviceConfigurerServiceSharedLibsModule,
    JhiLanguageHelper,
    FindLanguageFromKeyPipe,
    DcsAlertComponent,
    DcsAlertErrorComponent
} from './';


export function alertServiceProvider(sanitizer: Sanitizer, translateService: TranslateService) {
    // set below to true to make alerts look like toast
    let isToast = false;
    return new AlertService(sanitizer, isToast, translateService);
}

@NgModule({
    imports: [
        DeviceConfigurerServiceSharedLibsModule
    ],
    declarations: [
        FindLanguageFromKeyPipe,
        DcsAlertComponent,
        DcsAlertErrorComponent
    ],
    providers: [
        JhiLanguageHelper,
        {
            provide: AlertService,
            useFactory: alertServiceProvider,
            deps: [Sanitizer, TranslateService]
        },
        Title
    ],
    exports: [
        DeviceConfigurerServiceSharedLibsModule,
        FindLanguageFromKeyPipe,
        DcsAlertComponent,
        DcsAlertErrorComponent
    ]
})
export class DeviceConfigurerServiceSharedCommonModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/shared-common.module.ts